export default "__VITE_ASSET__Ztx6mxSo__"